export default "__VITE_ASSET__CQrXCMiu__"